import { useFeatures } from "components/FeaturesContext";

function trackOnce(value, suffix) {
  const tag = `ga_track_${value}${suffix || ''}`;
  if (window.sessionStorage.getItem(tag)) {
    return;
  }

  window.sessionStorage.setItem(tag, true);
  window?.gtag('event', value);
}

export function useTracker() {
  const features = useFeatures();

  let suffix = ''
  for (const key in features) {
    suffix += features[key].gaTagSuffix || '';
  }

  return (value) => trackOnce(value, suffix);
}